export enum ChannelIdentifier {
  IngersollRand = 'ingersoll-rand',
  GardnerDenver = 'gardner-denver',
  CompAir = 'compair',
  Showcase = 'showcase',
  Other = 'other',
}

type TierKey = 'monitor' | 'optimize';

export type BrandNamesSet = {
  packageNames: Partial<Record<TierKey, string>>;
  packagePrefixes: Partial<Record<TierKey, string>>;
};
const detectAndMaximizeBranding: BrandNamesSet = {
  packageNames: {
    monitor: 'Detect',
    optimize: 'Maximize',
  },
  packagePrefixes: {
    monitor: 'DET',
    optimize: 'MAX',
  },
};
const monitorAndOptimizeBranding: BrandNamesSet = {
  packageNames: {
    monitor: 'Monitor',
    optimize: 'Optimize',
  },
  packagePrefixes: {
    monitor: 'MON',
    optimize: 'OPT',
  },
};

const getGardnerDenverBranding = (region = ''): BrandNamesSet => {
  if (region === 'north-america') {
    return detectAndMaximizeBranding;
  }
  return monitorAndOptimizeBranding;
};

export function getResolvedBranding(company: ChannelIdentifier, region = ''): BrandNamesSet {
  switch (company) {
    case ChannelIdentifier.GardnerDenver:
      return getGardnerDenverBranding(region);
    default:
      return monitorAndOptimizeBranding;
  }
}

const getUniqueChannels = (items: { channelIdentifier: ChannelIdentifier }[]): ChannelIdentifier[] => {
  const identifiers = items.map(item => item.channelIdentifier).filter(item => item !== ChannelIdentifier.Showcase);
  return Array.from(new Set(identifiers));
};

const getMainChannel = (channels: ChannelIdentifier[]): ChannelIdentifier => {
  if (channels.length === 1) {
    return channels[0];
  }
  return ChannelIdentifier.IngersollRand;
};

export const getResolvedBrandingFromStations = (
  stations: { channelIdentifier: ChannelIdentifier }[],
  regions: string[],
): BrandNamesSet => {
  const channelIdentifiers = getUniqueChannels(stations);
  const mainChannelIdentifier = getMainChannel(channelIdentifiers);
  const region = regions.length === 1 ? regions[0] : '';
  return getResolvedBranding(mainChannelIdentifier, region);
};
